<template>
    <div class="u-reset home-intro-scroller" :class="[rootClasses]">
        <transition name="trs-simple-fade" mode="out-in">
            <router-link class="u-reset home-intro-scroller--wrap"
                    v-if="firstLocation && !showButton" key="scroller"
                    :to="firstLocation">
                <span class="home-intro-scroller--title"
                        v-text="translate('HOME.SCROLLER_TITLE')">
                </span>
                <div class="home-intro-scroller--visual">
                    <img class="home-intro-scroller--img"
                            :src="'img/im_scroll.svg' | static" alt="">
                    <div class="home-intro-scroller--ani"></div>
                </div>
            </router-link>
            <router-link class="btn btn__primary home-intro-scroller--btn"
                    v-if="firstLocation && showButton" key="btn"
                    :to="firstLocation"
                    v-text="translate('HOME.SCROLLER_TITLE')">
            </router-link>
        </transition>
    </div>
</template>

<script>
    import { touchevents } from 'modernizr';
    import { debounce } from 'lodash';
    import { mapGetters } from 'vuex';
    import { mapFilters } from 'util/vue/map-filters';
    import bemMixin from 'framework/mixins/bem';
    import isMountedMixin from 'framework/mixins/is-mounted';


    const htmlNode = document.documentElement;


    export default {
        mixins: [
            bemMixin('home-intro-scroller'),
            isMountedMixin,
        ],
        props: {
            firstLocation: {
                type: Object,
            },
        },
        computed: {
            ...mapGetters(['scroll', 'viewport', 'mapNav']),
            rootClasses() {
                return [
                    this.bemAdd(this.isScrollable ? 'is-scrollable' : ''),
                ];
            },
            hasTouch() {
                return touchevents;
            },
            isScrollable() {
                this.viewport.width; // eslint-disable-line no-unused-expressions
                return (!this.scroll.isLocked && htmlNode.scrollHeight > htmlNode.offsetHeight);
            },
            showButton() {
                return this.isScrollable || this.hasTouch;
            },
        },
        methods: {
            ...mapFilters(['translate']),
            onWheel: debounce(function(e) {
                if (this.mapNav.isActive || this.isScrollable || e.deltaY <= 0) {
                    return;
                }

                this.navigateToLocation();
            }, 200, {}),
            navigateToLocation() {
                if (!this.firstLocation) {
                    return;
                }

                this.$router.push(this.firstLocation);
            },
        },
        mounted() {
            window.addEventListener('wheel', this.onWheel, { passive: true });
        },
        beforeDestroy() {
            window.removeEventListener('wheel', this.onWheel, { passive: true });
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/home-intro-scroller/index.vue?a3bd4ef2